import { render, staticRenderFns } from "./TrainingRegistration_3.vue?vue&type=template&id=3d937b88&"
import script from "./TrainingRegistration_3.vue?vue&type=script&lang=js&"
export * from "./TrainingRegistration_3.vue?vue&type=script&lang=js&"
import style0 from "./TrainingRegistration_3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports